import { render, staticRenderFns } from "./Artical.vue?vue&type=template&id=8216535a&"
import script from "./Artical.vue?vue&type=script&lang=ts&"
export * from "./Artical.vue?vue&type=script&lang=ts&"
import style0 from "./Artical.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports